import classNames from 'classnames';
import React, { useLayoutEffect, useRef, useState } from 'react';
import * as styles from './DetailPreviewDescriptionContainer.module.scss';

interface DetailPreviewDescriptionContainerProps {
  contentReady: boolean;
  children: React.ReactNode;
  content: unknown;
}

const DetailPreviewDescriptionContainer = ({
  contentReady,
  children,
  content,
}: DetailPreviewDescriptionContainerProps) => {
  const referenceContainerRef = useRef<HTMLDivElement>(null);

  const [shouldShowOverlay, setShouldShowOverlay] = useState(true);

  useLayoutEffect(() => {
    const referenceContainer = referenceContainerRef.current;
    if (!referenceContainer) return undefined;

    const checkShowingOverlay = () => {
      if (referenceContainer.scrollHeight > referenceContainer.clientHeight) {
        setShouldShowOverlay(true);
      } else {
        setShouldShowOverlay(false);
      }
    };

    const resizeObserver = new ResizeObserver(checkShowingOverlay);
    resizeObserver.observe(referenceContainer);
    checkShowingOverlay();

    return () => resizeObserver.disconnect();
  }, [content]);

  return (
    <div
      className={classNames(styles.container, {
        [styles.withGradientMask]: shouldShowOverlay,
      })}
    >
      <div
        className={styles.referenceContainer}
        ref={referenceContainerRef}
        style={contentReady ? { overflow: 'hidden' } : undefined}
      >
        {children}
      </div>
    </div>
  );
};

export default DetailPreviewDescriptionContainer;
